import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Scale, ArrowRight } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1589994965851-a8f479c573a9" 
          alt="Lady Justice"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container hero-content">
        <div className="hero-icon">
          <Scale size={48} strokeWidth={1} />
        </div>
        <h1 className="hero-large">{t.hero.name}</h1>
        <p className="hero-subtitle">{t.hero.title}</p>
        <p className="hero-slogan">{t.hero.slogan}</p>
        <button onClick={scrollToContact} className="btn-primary">
          {t.hero.cta}
          <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
};

export default Hero;